import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import StarUpdateResponseLayer from "../components/StarUpdateResponseLayer";

const StarUpdateResponsePage = () => {
    return (
        <MasterLayout>
            <StarUpdateResponseLayer />
        </MasterLayout>
    );
};

export default StarUpdateResponsePage;
